import { render, staticRenderFns } from "./ClassificationOfGoods.vue?vue&type=template&id=2a626cb0&scoped=true&"
import script from "./ClassificationOfGoods.vue?vue&type=script&lang=js&"
export * from "./ClassificationOfGoods.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationOfGoods.vue?vue&type=style&index=0&id=2a626cb0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a626cb0",
  null
  
)

export default component.exports